import { Injectable } from '@angular/core';
import { UserWizardService } from '../../../services/user/user.wizard.service';
import {
  ApiService,
  InputDatastoreService,
  CountryListService,
  DialogService,
  UserService,
  ValuesExchangeProvider
} from '@nrwl/common-lib';

@Injectable()
export class AddUserWizardService extends UserWizardService {
  //eslint-disable-line
  constructor(
    apiService: ApiService,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService,
    readonly userService: UserService,
    valuesExchange: ValuesExchangeProvider
  ) {
    super(
      apiService,
      inputDatastoreService,
      countryListService,
      dialogService,
      userService,
      valuesExchange
    );
  }
  //------------------------------------------------ Wizard control ----------------------------------------------------

  onFinish() {
    const responseProcessed = this._saveWizardData();
    responseProcessed.subscribe(() => {
      this.currentStep = this.finishingStep;
      if (!this.requestFailed) {
        this.successMessage = 'User has been successfully added';
        this.valuesExchange.notifyListeners('user_admin_board', {
          value: 'update',
          cacheBreaker: Date.now()
        });
      }
    });
    return responseProcessed;
  }

  _handleErrorResponse(response) {
    this.errorMessage = 'User was not added';

    if (response && response.error && response.error.errors.length !== 0) {
      this.errorDescription = response.error.errors[0];
      if (this.errorDescription.indexOf('UserAlreadyExisting') !== -1) {
        this.errorDescription = 'User name already exists. Please pick another user name';
      }
    }
  }
}
